import { language } from 'curvy';

export const english: language.TranslationDefinition = {
    locale: 'en-us',
    translations: {
        "METERS.TITLE": "Meters",

        "METERS.DATE": "Date",
        "METERS.SERIAL": "Serial number",
        "METERS.NAME": "Name",
        "METERS.LOCATION": "Location",
        "METERS.READ": "Recorded",
        "METERS.VT": "VT",
        "METERS.NT": "NT",
        "METERS.POWER": "Power",
        "METERS.GAS_VAL": "Gas",
        "METERS.WATER_VAL": "Water",

        "METERS.TYPE": "Meter type",
        "METERS.READING_FROM": "Reading date from",
        "METERS.READING_TO": "Reading date to",
        "METERS.SERVICER": "Mobile servicer",

        "METERS.BRAND": "Brand",
        "METERS.FREQUENCY": "Frequency",
        "METERS.MEASURES": "Measures",

        "METERS.METERS": "Meters",
        "METERS.NO_METERS": "No meters at this location.",
        "METERS.ADD_METER": "Add meter",
        "METERS.SAVE_LOCATION_FIRST": "Save the location first, then reopen it to add meters.",
        "METERS.WILL_SAVE_WITH_LOCATION": "Meters added here will be created when you save the location.",
        "METERS.SAVE_FAILED": "Some meters could not be saved.",
        "METERS.DUPLICATE_SERIAL": (code) => `A meter with serial number "${code}" already exists at this location.`,
        "METERS.NO_TYPES": "No meter types defined (backend).",

        "METERS.READINGS": "Measurements",
        "METERS.FROM_MOBILE": "(recorded in the mobile app)",
        "METERS.NO_READINGS": "No measurements.",
        "METERS.ADD_READING": "New measurement",
        "METERS.SAVE_READING": "Save measurement",
        "METERS.PHOTO": "Photo",
        "METERS.RECORDED": "Recorded",
        "METERS.NOT_RECORDED": "Not recorded",
        "METERS.MISSING": "Missing this period",

        "METERS.FREQ.1": "Yearly",
        "METERS.FREQ.2": "Half-yearly",
        "METERS.FREQ.3": "Quarterly",
        "METERS.FREQ.4": "Monthly",
        "METERS.FREQ.5": "Weekly",
        "METERS.FREQ.6": "Daily",

        "METERS.TAB.FORM": "Form",
        "METERS.TAB.USERS": "Users",
        "METERS.TAB.METERS": "Meters",
    }
};

export const croatian: language.TranslationDefinition = {
    locale: 'hr-hr',
    translations: {
        "METERS.TITLE": "Brojila",

        "METERS.DATE": "Datum",
        "METERS.SERIAL": "Serijski broj",
        "METERS.NAME": "Naziv",
        "METERS.LOCATION": "Lokacija",
        "METERS.READ": "Očitano",
        "METERS.VT": "VT",
        "METERS.NT": "NT",
        "METERS.POWER": "Snaga",
        "METERS.GAS_VAL": "Plin",
        "METERS.WATER_VAL": "Voda",

        "METERS.TYPE": "Tip brojila",
        "METERS.READING_FROM": "Datum očitanja od",
        "METERS.READING_TO": "Datum očitanja do",
        "METERS.SERVICER": "Popisivač",

        "METERS.BRAND": "Proizvođač",
        "METERS.FREQUENCY": "Frekvencija",
        "METERS.MEASURES": "Mjere",

        "METERS.METERS": "Brojila",
        "METERS.NO_METERS": "Nema brojila na ovoj lokaciji.",
        "METERS.ADD_METER": "Dodaj brojilo",
        "METERS.SAVE_LOCATION_FIRST": "Prvo spremi lokaciju, pa je ponovno otvori za dodavanje brojila.",
        "METERS.WILL_SAVE_WITH_LOCATION": "Brojila dodana ovdje spremaju se kad spremiš lokaciju.",
        "METERS.SAVE_FAILED": "Neka brojila nisu spremljena.",
        "METERS.DUPLICATE_SERIAL": (code) => `Brojilo sa serijskim brojem "${code}" već postoji na ovoj lokaciji.`,
        "METERS.NO_TYPES": "Nema definiranih tipova brojila (backend).",

        "METERS.READINGS": "Očitanja",
        "METERS.FROM_MOBILE": "(unose se na mobilnoj aplikaciji)",
        "METERS.NO_READINGS": "Nema očitanja.",
        "METERS.ADD_READING": "Novo očitanje",
        "METERS.SAVE_READING": "Spremi očitanje",
        "METERS.PHOTO": "Slika",
        "METERS.RECORDED": "Očitano",
        "METERS.NOT_RECORDED": "Nije očitano",
        "METERS.MISSING": "Nedostaje ovaj period",

        "METERS.FREQ.1": "Godišnje",
        "METERS.FREQ.2": "Polugodišnje",
        "METERS.FREQ.3": "Kvartalno",
        "METERS.FREQ.4": "Mjesečno",
        "METERS.FREQ.5": "Tjedno",
        "METERS.FREQ.6": "Dnevno",

        "METERS.TAB.FORM": "Forma",
        "METERS.TAB.USERS": "Korisnici",
        "METERS.TAB.METERS": "Brojila",
    }
};

export const meters_translations = [english, croatian];
